import { render, staticRenderFns } from "./main-information-card.vue?vue&type=template&id=38040c2c&scoped=true"
import script from "./main-information-card.vue?vue&type=script&lang=js"
export * from "./main-information-card.vue?vue&type=script&lang=js"
import style0 from "./main-information-card.vue?vue&type=style&index=0&id=38040c2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38040c2c",
  null
  
)

export default component.exports